import Demo from "./components/Demo"
import HomeCards from "./components/HomeCards"
import HomeHero from "./components/HomeHero"
import Homes from "./components/Homes"

export default function Homepage() {
  return (
    <>
      <section>
        <HomeHero />
        <HomeCards />
        <Homes />
        <Demo />
      </section>
    </>
  )
}
